import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKalenderHerinnering = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      d="M32 10H8v22h24z"
    />
    <path
      fill="#85E3F9"
      d="M32 13.89H8V32h24z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M11.5 12V8h1v4zM15.5 12V8h1v4zM19.5 12V8h1v4zM23.5 12V8h1v4zM27.5 12V8h1v4z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M28 19.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M28 24.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M28 29.57a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M12 24.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M12 29.57a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M17.33 19.43a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M17.33 24.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M17.33 29.57a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M22.67 19.43a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M22.67 24.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M22.67 29.57a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m18.677 24.994-3.39-3.39.707-.708 3.39 3.39z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m15.287 24.286 3.39-3.39.707.708-3.39 3.39z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKalenderHerinnering);

export default ForwardRef;
